
import DashbordNav from "../DashbordNav/DashbordNav";

const Dashborad = () => {
   

    return (
       <div className="container">
           <DashbordNav></DashbordNav>
         

         


       </div>
    );
};

export default Dashborad;